import   React,
       { useEffect,
         useState,
         useRef,
         useContext } from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { Typography,
         Container } from '@material-ui/core';
import TextField from '@material-ui/core/TextField';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes,
         faSyncAlt } from '@fortawesome/free-solid-svg-icons';     //icons: https://fontawesome.com/icons
import {
         FaSun,         // today
         FaDumbbell,    // condition
         FaHandPointer, // agility
         FaBullsEye,    // skill
         FaStopWatch,   // challenge
         FaFilm,        // film
         FaAnalytics,   // analyze
         FaMedal,       // score
         } from '../assets/Icons';     //icons: https://fontawesome.com/icons

import Carousel from 'react-bootstrap/Carousel'     // sudo yarn add  react-bootstrap bootstrap@5.0.2
import { BarGraph } from "./Graph";

import { appContext } from "./index";
import { CONSTS, INFO } from '../util/object'
import { AuthClass } from '../class/AuthClass';
//import { AXOS_VERSION } from '../version';
import Player from '@vimeo/player';
import { UTIL_useStyles,
         Avatar } from "./Util";

var auth = new AuthClass();


// <SwitchUser>  - only for admin, show possible user to switch to
//
const switchuser_useStyles = makeStyles(theme => ({
    switchuser_root: {    // use absolute position to float atop
        height: '100%',
        width: '100%',
        padding: "0",
        position: 'absolute',
        top: '0',
        left: '0',
        zIndex: '600',      // MUST BE ON TOP!  below the wait spinner (500)   was: 250
        backgroundColor: '#7b7e9a9c',
    },
    switchuser_container: {        // use this to create the dialog shape
        display: 'flex',
        flexDirection: 'column',
        position: 'relative',
        padding: '25px',
        width: "85%",
        height: "80%", 
        //maxHeight: '300px',
        maxWidth: '480px',
        margin: '10vh auto',

        alignItems: "flex-start",
        justifySelf: 'center',

        borderColor: 'rgba(255,255,255,0)',
        borderRadius: '12px',
        border: '0px',
        boxShadow: 'rgba(50, 50, 93, 0.35) 0px 6px 12px -2px, rgba(0, 0, 0, 0.45) 0px 5px 10px -3px',
        backgroundColor: '#6f3e4df8',
        overflow: 'hidden',
    },
    switchuser_inner_container: {
        display: 'flex',
        flexDirection: "column",
        position: 'relative',
        width: '100%',
        margin: '0',
        padding: '0px 15px',
        overflow: 'auto',
    },
    switchuser_row: {
        display: 'flex',
        margin: '0 0 10px 0',
        padding: '0',
        width: '100%',
        height: '100%',
        flexDirection: 'row',
    },
    switchuser_text: {
        //fontWeight: 'bold',
        fontSize: '0.8rem',
        color: '#dfd0d0',
        padding: '0 0 0 5px',
        alignSelf: 'center',
    },

    catalog_icon_body: {
        position: 'absolute',
        bottom: '4px',
        left: '4px',
        width: 'auto',
        height: 'auto',
        margin: '0',
        padding: '0',
    },

}));

export const SwitchUser = (props) => {
    const classes = switchuser_useStyles();
    const Classes = UTIL_useStyles();
    var Items = props.Items;
    const [ Users, setUsers ] = useState([]);

    useEffect(() => {
        console.log("switch_user.92:  ###### ADMIN Show <SwitchUser>  ");
    }, [1] );

    useEffect(() => {
        console.log("switch_user.92:  ###### ADMIN Show <SwitchUser>  ");
        var users = [...props.Users];
        users.sort(arrayCreatedDesSort);
        setUsers(users);
    }, [props.Users] );

    const handleSwitchUser = user => event => {
        console.log("swtich.116: ----->  REACHED SWITCH USER user=", user);
        INFO.god_mode = true;
        INFO.god_players = JSON.parse(JSON.stringify(INFO.db_players));
        props.SwitchAction(user);
    }

    /// UTIL: sort array based on sequence
    function arrayCreatedDesSort(a, b) {
        var field = "created"
        if (a[field] == b[field]) {
            return 0;
        }
        else {
            return (a[field] > b[field]) ? -1 : 1;
        }
    }



    return (
        <React.Fragment>
            <Container id="switchuser_root" className={classes.switchuser_root} >
                <Container id="switchuser_container" className={classes.switchuser_container} >

                    <Container id="switchuser_dismiss" className={Classes.dismiss_summary_container} onClick={props.Dismiss} >
                        <FontAwesomeIcon 
                            className={Classes.dismiss_icon}
                            icon={faTimes}
                            style={{ fontSize: "1.5rem"}} />
                    </Container>
                <Container id="switchuser_inner" className={classes.switchuser_inner_container} >

                    {Users && Users.map( (user, index) => {
                        var hash = null;
                        return (
                                <Container key={"item_"+index} className={classes.switchuser_row} onClick={handleSwitchUser(user)} >
                                    <Avatar id="avatar6" Image={user.avatar}  Style={{height: "20px"}} />
                                    <Container key={'txt_'+index} className={classes.switchuser_text}> {user.name + " - "}{user.key} </Container>
                                </Container>
                        )}
                    )}

                </Container>
                </Container>
            </Container>

        </React.Fragment>
    )
}

